"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _Modal_Func = _interopRequireDefault(require("./Modal_Func"));

var _Modal_Class = _interopRequireDefault(require("./Modal_Class"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var Dropdown = function Dropdown(props) {
  if (props.modalButtons && props.modalContent) console.warn("You my friend, have provided both 'modalButtons' and 'modalContent' prop. Only 'modalButtons' is getting rendered.");else if (!props.modalButtons && !props.modalContent) console.warn("Neither 'modalButtons', nor 'modalContent' has been provided as prop.");
  return React.createElement(React.Fragment, null, React.createElement("div", {
    style: {
      cursor: 'pointer'
    },
    onClick: function onClick(e) {
      props.onButtonClick(e);
    }
  }, props.children ? props.children : 'Dropdown'), props.visible && React.createElement(React.Fragment, null, props.animation ? React.createElement(_Modal_Class.default, props) : React.createElement(_Modal_Func.default, props)));
};

var _default = Dropdown;
exports.default = _default;